//
// This file has been generated by [index-modules](https://npmjs.com/index-modules)
//

const properties = {}

import _acls, * as __acls from "./acls"
properties.acls = { enumerable: true, get: () => _acls }
export { __acls as acls }

import _api, * as __api from "./api"
properties.api = { enumerable: true, get: () => _api }
export { __api as api }

import _authentication, * as __authentication from "./authentication"
properties.authentication = { enumerable: true, get: () => _authentication }
export { __authentication as authentication }

import _backups, * as __backups from "./backups"
properties.backups = { enumerable: true, get: () => _backups }
export { __backups as backups }

import _configManagement, * as __configManagement from "./config-management"
properties.configManagement = { enumerable: true, get: () => _configManagement }
export { __configManagement as configManagement }

import _ipPools, * as __ipPools from "./ip-pools"
properties.ipPools = { enumerable: true, get: () => _ipPools }
export { __ipPools as ipPools }

import _jobs, * as __jobs from "./jobs"
properties.jobs = { enumerable: true, get: () => _jobs }
export { __jobs as jobs }

import _plugins, * as __plugins from "./plugins"
properties.plugins = { enumerable: true, get: () => _plugins }
export { __plugins as plugins }

import _remotes, * as __remotes from "./remotes"
properties.remotes = { enumerable: true, get: () => _remotes }
export { __remotes as remotes }

import _resourceSets, * as __resourceSets from "./resource-sets"
properties.resourceSets = { enumerable: true, get: () => _resourceSets }
export { __resourceSets as resourceSets }

import _scheduling, * as __scheduling from "./scheduling"
properties.scheduling = { enumerable: true, get: () => _scheduling }
export { __scheduling as scheduling }

import _store, * as __store from "./store"
properties.store = { enumerable: true, get: () => _store }
export { __store as store }

import _subjects, * as __subjects from "./subjects"
properties.subjects = { enumerable: true, get: () => _subjects }
export { __subjects as subjects }

import _xenServers, * as __xenServers from "./xen-servers"
properties.xenServers = { enumerable: true, get: () => _xenServers }
export { __xenServers as xenServers }

export default Object.create(null, properties)
